module.exports = __webpack_public_path__ + "img/semi-select.ba6ea881.svg";